import { webApi } from '@mi-front/api-clients';

/**
 * Fetches composition detail by id (BFF).
 */
export function useCompositionQuery(compositionId: string) {
  return webApi.useGetCompositionsDetailById(compositionId, {
    query: {
      enabled: !!compositionId,
    },
  });
}
